module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap p-t-lg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "p-t-md"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loading === 1) ? _c('loading', {
    staticStyle: {
      "min-height": "620px"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading === 0),
      expression: "loading === 0"
    }],
    staticClass: "evaluate n-m-t"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s((_vm.company && _vm.company._id ? (_vm.evaluate.alias ? _vm.evaluate.alias : _vm.evaluate.name) : _vm.evaluate.name) + (_vm.company && _vm.company._id ? ('-' + _vm.company.name) : '')))]), _vm._v(" "), _c('div', {
    staticClass: "infos"
  }, [_c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.evaluate.evaluate_num) + "人测试过")]), _vm._v(" "), _c('span', {
    staticClass: "item hidden-xs"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.evaluate.create_at)) + "发布")]), _vm._v(" "), _c('span', {
    staticClass: "item right"
  }, [_vm._v("本次测试共\n              "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.evaluate.questions_num))]), _vm._v("题")])]), _vm._v(" "), (_vm.evaluate.desc) ? _c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.evaluate.desc)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading === 0),
      expression: "loading === 0"
    }],
    staticClass: "row m-t-sm p-t-xs",
    staticStyle: {
      "min-height": "300px"
    }
  }, [(_vm.loading === 0 && _vm.evaluate.report_type === 1) ? _c('normal-tpl', {
    attrs: {
      "code": _vm.code,
      "questionnaire": _vm.evaluate,
      "tester": _vm.tester
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading === 0 && _vm.evaluate.report_type === 2) ? _c('dimension-tpl', {
    attrs: {
      "code": _vm.code,
      "questionnaire": _vm.evaluate,
      "tester": _vm.tester
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row p-t-b-md text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-md btn-primary",
    attrs: {
      "to": "/evaluate"
    }
  }, [_vm._v("参与更多测评，完善个人档案 >>")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59ab84b8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/evaluate/report/show.vue
// module id = 480
// module chunks = 1